import firebase from 'firebase';

const config = {
    apiKey: "AIzaSyCiYjDiQ_tCZCY63q97ALEC36B01aV20qk",
    authDomain: "teste-3cad5.firebaseapp.com",
    databaseURL: "https://teste-3cad5.firebaseio.com",
    projectId: "teste-3cad5",
    storageBucket: "teste-3cad5.appspot.com",
    messagingSenderId: "272890912588"
};

const base = firebase.initializeApp(config)

export default base